import api from './api';

// Field Configuration Service
export const fieldConfigService = {
  // Get form configuration
  async getFormConfiguration(formId) {
    const response = await api.get(`/admin/forms/${formId}/configuration`);
    return response.data;
  },

  // Save entire configuration (used for all field operations)
  async saveConfiguration(formId, configuration) {
    const response = await api.put(`/admin/forms/${formId}/configuration`, configuration);
    return response.data;
  },

  // Auto-configure form (AI)
  async autoConfigureForm(formId) {
    const response = await api.post(`/admin/forms/${formId}/auto-configure`);
    return response.data;
  },

  // Re-analyze fields
  async reAnalyzeFields(formId) {
    const response = await api.post(`/admin/forms/${formId}/re-analyze`);
    return response.data;
  },

  // Reset configuration
  async resetConfiguration(formId) {
    const response = await api.delete(`/admin/forms/${formId}/configuration`);
    return response.data;
  },

  // Copy fields from source form to target form
  async copyFieldsToForm(sourceFormId, targetFormId) {
    const response = await api.post(`/forms/${sourceFormId}/copy-fields-to/${targetFormId}`);
    return response.data;
  },

  // Score saved field boxes (ink / overlap). Used after explicit Save All only.
  async getFieldQuality(formId) {
    const response = await api.get(`/admin/forms/${formId}/field-quality`);
    return response.data;
  }
};

export default fieldConfigService;
